import React from 'react'
import { useTranslation } from 'react-i18next'

import { Layout } from './Layout'

export const SurveyStats = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className={'status-message info margin-top-large'}>
        <p>{t('Under construction')}</p>
      </div>
    </Layout>
  )
}
